import httpClient from "./http-client";

/**
 * Looks up an enquiry by its acknowledgement number.
 *
 * Public endpoint — no auth. Returns only customer-safe fields:
 * the acknowledgement number, current status, timeline and status dates.
 */
export const trackEnquiry = async (acknowledgementNumber) => {
  const response = await httpClient.get(
    `/public/track/${encodeURIComponent(acknowledgementNumber)}`
  );
  return response.data.data;
};

/** Normalized the same way the backend does, so what the user sees is what is sent. */
export const normalizeAckNumber = (value) =>
  String(value ?? "").replace(/\s+/g, "").toUpperCase();
